import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import { useSelector } from 'react-redux';
import { authSelector } from 'redux/auth/selectors';
import SocketServiceFactory from 'websockets/service/SocketServiceFactory';
import { getAnonymousUserIdentity } from 'utils/Helper';

const service = SocketServiceFactory();

const QvrfContainer = ({
    children,
    loaderHeight,
    loaderWidth,
    config,
    showSkeleton,
}) => {
    const [socket, setSocket] = useState(null);
    const {
        isAuthenticated,
        user: { _id },
    } = useSelector(authSelector);

    const identity = isAuthenticated ? _id : getAnonymousUserIdentity();

    const getSocket = useCallback(async () => {
        try {
            if (config.appId) {
                const socket = await service.getOrCreateSocket({
                    ...config,
                    isAuthenticated,
                    identity,
                });
                setSocket(socket);
            }
        } catch (err) {
            console.error(err);
        }
    }, [config]);

    useEffect(() => {
        getSocket();
    }, [getSocket]);

    if (!socket) {
        return showSkeleton ? (
            <Skeleton
                variant="rect"
                width={loaderWidth}
                height={loaderHeight}
            />
        ) : null;
    }

    return <>{React.cloneElement(children, { socket: socket })}</>;
};

QvrfContainer.propTypes = {
    children: PropTypes.element.isRequired,
    config: PropTypes.object.isRequired,
    loaderHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    loaderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showSkeleton: PropTypes.bool,
};

QvrfContainer.defaultProps = {
    loaderHeight: 118,
    loaderWidth: '100%',
    showSkeleton: true,
};
export default QvrfContainer;
